import Vue from 'vue'
import Router from 'vue-router'
import HomePgae from './components/pages/HomePage'
import SignupPage from './components/pages/SignupPage'
import LoginPage from './components/pages/LoginPage'
import LogoutPage from './components/pages/LogoutPage'
import UserInfoPage from './components/pages/UserInfoPage'
import TopicDetailPage from './components/pages/TopicDetailPage'
import TopicCreatePage from './components/pages/TopicCreatePage'
import TopicEditPage from './components/pages/TopicEditPage'
import ErrorPage from './components/pages/ErrorPage'
import EmailVerifiyPage from './components/pages/EmailVerifiyPage'
import FavoriteTopicsPage from './components/pages/FavoriteTopicsPage'
import TopicDraftPage from './components/pages/TopicDraftPage'
import SearchResultPage from './components/pages/SearchResultPage'
import SignupConfirmPage from './components/pages/SignupConfirmPage'
import GoogleSignupPage from './components/pages/GoogleSignupPage'
import GithubSignupPage from './components/pages/GithubSignupPage'
import LittleHeroesSignupPage from './components/pages/LittleHeroesSignupPage'
import SignupSuccessPage from './components/pages/SignupSuccessPage'
import TopicPermissionApprovalPage from './components/pages/TopicPermissionApprovalPage'
import ThankYouPage from './components/pages/ThankYouPage'
import UserEditPage from './components/pages/UserEditPage'
import PasswordResetPage from './components/pages/PasswordResetPage'
import PasswordResetInputPage from './components/pages/PasswordResetInputPage'
import PasswordResetSuccessPage from './components/pages/PasswordResetSuccessPage'
import PasswordResetFailedPage from './components/pages/PasswordResetFailedPage'
import FavoriteUsersPage from './components/pages/FavoriteUsersPage'
import LoadPage from './components/pages/LoadPage'
import GoogleCallBack from './components/pages/GoogleCallBack'
import GithubCallBack from './components/pages/GithubCallBack'
import LittleHeroesCallBack from './components/pages/LittleHeroesCallBack'
import TopicDraftListPage from './components/pages/TopicDraftListPage'
import PrivacyPage from './components/pages/PrivacyPage'
import TermsPage from './components/pages/TermsPage'
import InquiryPage from './components/pages/InquiryPage'
import InquiryFinishPage from './components/pages/InquiryFinishPage'
import NotificationIndexPage from './components/pages/NotificationIndexPage'
import CompanyPage from './components/pages/CompanyPage.vue'
import Error404 from './components/organisms/Error/Error404.vue'
import HelpPage from './components/pages/HelpPage.vue'

import store from './store/'

Vue.use(Router)

const router = new Router({
	scrollBehavior() {
        return { x: 0, y: 0 };
    },
	mode: 'history',
	routes: [
		{
			//ホーム
			path: '/',
			name: 'home',
			component: HomePgae
		},
		{
			//ユーザ登録
			path: '/signup',
			name: 'signup',
			component: SignupPage
		},
		{
			//Google認証 TODO: 後でまとめる
			path: '/login/google',
			name: 'googleSignup',
			component: GoogleSignupPage
		},
		{
			//Google認証 TODO: 後でまとめる
			path: '/login/google/callback',
			name: 'googleCallBack',
			component: GoogleCallBack
		},
		{
			//Github認証 TODO: 後でまとめる
			path: '/login/github',
			name: 'githubSignup',
			component: GithubSignupPage
		},
		{
			//Github認証 TODO: 後でまとめる
			path: '/login/github/callback',
			name: 'githubCallBack',
			component: GithubCallBack
		},
		{
			path: '/login/little-heroes',
			name: 'littleHeroesSignup',
			component: LittleHeroesSignupPage
		},
		{
			path: '/login/little-heroes/callback',
			name: 'littleHeroesCallBack',
			component: LittleHeroesCallBack
		},
		{
			//ログイン
			path: '/login',
			name: 'login',
			component: LoginPage
		},
		{
			//ログアウト
			path: '/logout',
			name: 'logout',
			component: LogoutPage
		},
		{
			//ユーザ登録確認
			path: '/signup/confirm',
			name: 'signup_confirm',
			component: SignupConfirmPage
		},
		{
			//ユーザ登録完了
			path: '/signup/success',
			name: 'signup_success',
			component: SignupSuccessPage
		},
		{
			//ユーザ登録失敗
			path: '/thank_you',
			name: 'thank_you',
			component: ThankYouPage
		},
		{
			//ユーザ詳細
			path: '/user/:user_code',
			name: 'user',
			component: UserInfoPage,
		},
		{
			//ユーザ編集※基本情報
			path: '/user/edit/:mode',
			name: 'user_edit',
			component: UserEditPage,
			meta: { requiresAuth: true }
		},
		{
			//パスワードリセット
			path: '/password_reset/',
			name: 'password_reset',
			component: PasswordResetPage,
		},
		{
			//新パスワード入力
			path: '/password_reset/:token',
			name: 'password_reset_input',
			component: PasswordResetInputPage,
		},
		{
			//パスワードリセット成功※未実装
			path: '/password_reset/success',
			name: 'password_reset_success',
			component: PasswordResetSuccessPage,
		},
		{
			//パスワードリセット失敗
			path: '/password_reset/failed',
			name: 'password_reset_failed',
			component: PasswordResetFailedPage,
		},
		{
			//トピック詳細
			path: '/topic/:topic_code',
			name: 'topic',
			component: TopicDetailPage,
		},
		{
			//トピック作成
			path: '/topic_create/',
			name: 'topic_create',
			component: TopicCreatePage,
			meta: { requiresAuth: true }
		},
		{
			//トピック編集
			path: '/topic/edit/:topic_code',
			name: 'topic_edit',
			component: TopicEditPage,
			meta: { requiresAuth: true }
		},
		{
			//トピック下書き
			path: '/topic/draft/:topic_code',
			name: 'topic_draft',
			component: TopicDraftPage,
			meta: { requiresAuth: true }
		},
		{
			//トピック権限承認
			path: '/topic_permission/:token',
			name: 'topic_permission_approval',
			component: TopicPermissionApprovalPage
		},
		{
			//エラー
			path: '/error',
			name: 'error',
			component: ErrorPage,
		},
		{
			//メール
			path: '/email_verifiy/:email_token',
			name: 'email_verifiy',
			component: EmailVerifiyPage,
		},
		{
			//お気に入りトピック一覧
			path: '/fovorite_topics',
			name: 'favorite_topics',
			component: FavoriteTopicsPage,
			meta: { requiresAuth: true }
		},
		{
			//お気に入りユーザ一覧
			path: '/fovorite_users',
			name: 'favorite_users',
			component: FavoriteUsersPage,
			meta: { requiresAuth: true }
		},
		{
			//下書き一覧
			path: '/draft_list',
			name: 'draft_list',
			component: TopicDraftListPage,
			meta: { requiresAuth: true }
		},
		{
			//検索結果
			path: '/search_result',
			name: 'SearchResultPage',
			component: SearchResultPage
		},
		{
			//ロード画面
			path: '/loading/:path',
			name: 'LoadPage',
			component: LoadPage
		},
		{
			// 個人情報の取り扱い
			path: '/privacy',
			name: 'privacy',
			component: PrivacyPage
		},
		{
			// 利用規約
			path: '/terms',
			name: 'terms',
			component: TermsPage
		},
		{
			// お問い合わせ
			path: '/inquiry',
			name: 'inquiry',
			component: InquiryPage
		},
		{
			// お問い合わせ完了
			path: '/inquiry/finish',
			name: 'inquiryFinish',
			component: InquiryFinishPage
		},
		{
			// 通知一覧
			path: '/notification',
			name: 'notification',
			component: NotificationIndexPage
		},
		{
			// 運営会社
			path: '/company',
			name: 'company',
			component: CompanyPage
		},
		/** ヘルプページ **/
		{
			// 運営会社
			path: '/help',
			name: 'help',
			component: HelpPage
		},
		{
			// 運営会社
			path: '/help/vlatips',
			name: '/help/vlatips',
			component: HelpPage
		},
		{
			path: '/help/article',
			name: 'help/article',
			component: HelpPage
		},
		{
			path: '/help/history',
			name: 'help/history',
			component: HelpPage
		},
		{
			path: '/help/origin',
			name: 'help/origin',
			component: HelpPage
		},
		{
			path: '/help/guideline',
			name: 'help/guideline',
			component: HelpPage
		},
		{
			path: '/help/setting',
			name: 'help/setting',
			component: HelpPage
		},
		{
			path: '/help/setting/icon',
			name: 'help/setting/icon',
			component: HelpPage
		},
		{
			path: '/help/setting/profile',
			name: 'help/setting/profile',
			component: HelpPage
		},
		{
			path: '/help/setting/email',
			name: 'help/setting/email',
			component: HelpPage
		},
		{
			path: '/help/setting/password',
			name: 'help/setting/password',
			component: HelpPage
		},
		{
			path: '/help/setting/pr',
			name: 'help/setting/pr',
			component: HelpPage
		},
		{
			path: '/help/setting/account-link',
			name: 'help/setting/account-link',
			component: HelpPage
		},
		{
			path: '/help/setting/account-leave',
			name: 'help/setting/account-leave',
			component: HelpPage
		},
		{
			path: '/help/function',
			name: 'help/function',
			component: HelpPage
		},
		{
			path: '/help/function/member',
			name: 'help/function/member',
			component: HelpPage
		},
		{
			path: '/help/function/favorite/member',
			name: 'help/function/favorite/member',
			component: HelpPage
		},
		{
			path: '/help/function/favorite/topic',
			name: 'help/function/favorite/topic',
			component: HelpPage
		},
		{
			path: '/help/function/topic',
			name: 'help/function/topic',
			component: HelpPage
		},
		{
			path: '/help/function/search',
			name: 'help/function/search',
			component: HelpPage
		},
		{
			path: '/help/function/notification',
			name: 'help/function/notification',
			component: HelpPage
		},
		{
			path: '/help/function/ranking',
			name: 'help/function/ranking',
			component: HelpPage
		},
		{
			path: '/help/function/pr',
			name: 'help/function/pr',
			component: HelpPage
		},
		{
			path: '/help/function/qr',
			name: 'help/function/qr',
			component: HelpPage
		},
		{
			path: '/help/function/notice',
			name: 'help/function/notice',
			component: HelpPage
		},
		{
			path: '/help/function/tag',
			name: 'help/function/tag',
			component: HelpPage
		},
		{
			path: '/help/topic',
			name: 'help/topic',
			component: HelpPage
		},
		{
			path: '/help/topic/info',
			name: 'help/topic/info',
			component: HelpPage
		},
		{
			path: '/help/topic-parts/info',
			name: 'help/topic-parts/info',
			component: HelpPage
		},
		{
			path: '/help/topic/image',
			name: 'help/topic/image',
			component: HelpPage
		},
		{
			path: '/help/topic/authority',
			name: 'help/topic/authority',
			component: HelpPage
		},
		{
			path: '/help/topic/import',
			name: 'help/topic/import',
			component: HelpPage
		},
		{
			path: '/help/topic/export',
			name: 'help/topic/export',
			component: HelpPage
		},
		{
			path: '/help/topic/markdown',
			name: 'help/topic/markdown',
			component: HelpPage
		},
		{
			path: '/help/topic/request',
			name: 'help/topic/request',
			component: HelpPage
		},
		{
			path: '/help/topic/copy',
			name: 'help/topic/copy',
			component: HelpPage
		},
		{
			path: '/help/topic/qr',
			name: 'help/topic/qr',
			component: HelpPage
		},
		{
			path: '/help/topic/deadlink',
			name: 'help/topic/deadlink',
			component: HelpPage
		},
		{
			path: '/help/auth',
			name: 'help/auth',
			component: HelpPage
		},
		{
			path: '/help/auth/oauth',
			name: 'help/auth/oauth',
			component: HelpPage
		},
		{
			path: '/help/auth/email',
			name: 'help/auth/email',
			component: HelpPage
		},
		{
			path: '/help/auth/password',
			name: 'help/auth/password',
			component: HelpPage
		},
		{
			path: '/help/auth/sns',
			name: 'help/auth/sns',
			component: HelpPage
		},
		/** エラーページ **/
		{
			// 存在しないパス
			path: '*',
			name: 'Error404',
			component: Error404
		}
	],
})

router.beforeEach((to, from, next) => {
	router['referrer'] = from;
  if (to.matched.some(page => page.meta.requiresAuth) && !store.state.auth.accessToken) {
	next({path: '/login', query: to.query});
  } else {
    next();
  }
});

export default router